export const FRONT_API_ENDPOINT = {
  SUBMIT_LEAD: () => '/api/submit-lead/'
}
